angular.module('app')
	.directive('circularLogoSlogan', circularLogoSlogan);

	circularLogoSlogan.$inject = [];
	function circularLogoSlogan() {
		return {
			restrict: 'EA',
			link: link,
			template: ''
		};

		function link(scope, element, attrs) {
			var isMobile = window.matchMedia("only screen and (max-width: 1023px)").matches;
			if (attrs.slogans) {
				var txt = attrs.slogans.split('');
				var elem = document.getElementById($(element).attr('id'));

				var deg = 360 / txt.length,
				  origin = 0;

				var radius = attrs.radius !== undefined ? parseInt(attrs.radius) : 50
				if (isMobile && attrs.radiusMobile !== undefined) {
					radius = parseInt(attrs.radiusMobile);
				}

				txt.forEach((ea) => {
					ea = `<span style='height:${radius}px; transform:rotate(${origin}deg);'>${ea}</span>`;
					elem.innerHTML += ea;
					origin += deg;
				});
			}
		}
	}

//****

circularLogoSloganController.$inject = ['$scope', '$element']
function circularLogoSloganController($scope, $element) {
	var ctrl = this;
}